/**
 * @typedef AT_UPDATE_STEP
 * @property {string} symbol 코인 명
 * @property {AT_UPDATE_STEP_ITEM[]} list 저장/수정/삭제 할 데이터 리스트
 *
 */

import { authFetch } from "@/plugins/axiosConfig";

/**
 * @typedef AT_UPDATE_STEP_ITEM 저장/수정/삭제할 데이터 아이템
 * @property {number|null} id 단계별 pk
 * @property {double} price 매수 금액
 * @property {double} percent 퍼센트
 */

const buyStepStore = {
  namespaced: true,
  state: {
    init: true,
    buy: {
      long: {
        BTCUSDT: [],
        ETHUSDT: [],
        XRPUSDT: [],
        SOLUSDT: [],
        ADAUSDT: [],
        DOGEUSDT: [],
        BNBUSDT: [],
      },
      short: {
        BTCUSDT: [],
        ETHUSDT: [],
        XRPUSDT: [],
        SOLUSDT: [],
        ADAUSDT: [],
        DOGEUSDT: [],
        BNBUSDT: [],
      },
    },
    sell: {
      long: {
        BTCUSDT: [],
        ETHUSDT: [],
        XRPUSDT: [],
        SOLUSDT: [],
        ADAUSDT: [],
        DOGEUSDT: [],
        BNBUSDT: [],
      },
      short: {
        BTCUSDT: [],
        ETHUSDT: [],
        XRPUSDT: [],
        SOLUSDT: [],
        ADAUSDT: [],
        DOGEUSDT: [],
        BNBUSDT: [],
      },
    },
  },
  getters: {
    IS_INIT: (state) => state.init,
    BUY_STEPS: (state) => state.buy,
    SELL_STEPS: (state) => state.sell,
    CURRENT_STEP: (state) => (orderType, position, symbol) => {
      let lastFilledIndex = state[orderType][position][symbol].findLastIndex(
        (f) => f.stepStats === "FILLED"
      );
      let isFilled = true;

      if (lastFilledIndex < 0) {
        lastFilledIndex = state[orderType][position][symbol].findIndex(
          (f) => f.stepStats == "NEW"
        );
        isFilled = false;
      }
      return {
        step: lastFilledIndex,
        data: state[orderType][position][symbol][lastFilledIndex],
        isFilled: isFilled,
        isNext: lastFilledIndex < state[orderType][position][symbol].length - 1,
      };
    },
    ALL_STEP: (state) => (orderType, position, symbol) => {
      return state[orderType][position][symbol];
    },
    BUY_INIT_STEP: (state) => (position, symbol) => {
      return state["buy"][position][symbol].find((f) => f.stepStats === "INIT");
    },
  },
  mutations: {
    // MU_BUY_SAVE_STEPS: (state, payload) => {
    //   if (payload != null && payload.length > 0) {
    //     const tempData = payload.map((data, index) => {
    //       return {
    //         id: data.orderSeq,
    //         price: data.avgPrice,
    //         percent: data.percent,
    //         isTraded: data.status == "FILLED",
    //         step: index + 1,
    //       };
    //     });
    //     state[orderType][position][payload.symbol] = tempData;
    //   }
    // },
    MU_TEMP: () => {},

    MU_API_UPDATE: (state, { buyType, sellType }) => {
      let { longOrder: buyLong, shortOrder: buyShort } = buyType;
      let { longOrder: sellLong, shortOrder: sellShort } = sellType;

      function convertKeyUpperCase(_object) {
        return Object.fromEntries(
          Object.entries(_object).map(([key, value]) => [
            key.toUpperCase(),
            value,
          ])
        );
      }

      state.buy.long = {
        ...state.buy.long,
        ...convertKeyUpperCase(buyLong),
      };
      state.buy.short = {
        ...state.buy.short,
        ...convertKeyUpperCase(buyShort),
      };
      state.sell.long = {
        ...state.sell.long,
        ...convertKeyUpperCase(sellLong),
      };
      state.sell.short = {
        ...state.sell.short,
        ...convertKeyUpperCase(sellShort),
      };
    },

    MU_SELL_UPDATE: (state, { symbol, position, ...etc }) => {
      state.sell[position][symbol] = [{ ...etc }];
    },

    MU_TEST: () => {},
  },

  actions: {
    /**
     * 매수 설정 데이터 업데이트
     * @param {Object} param0
     * @param {AT_UPDATE_STEP} payload
     */
    AT_BUY_UPDATE_STEP: async ({ commit }, payload) => {
      // api 로직 작성 예정

      commit("MU_BUY_SAVE_STEPS", payload);
    },

    /**
     * 사용자 매수/매도 단계 전체 조회
     * @param {*} param0
     */
    AT_ALL_STEP_LOAD: async ({ commit }) => {
      const response = await authFetch.get("/api/order/all/step");
      const { buyType, sellType } = response.data;
      commit("MU_API_UPDATE", { buyType, sellType });
    },

    /**
     *
     * @param {*} param0
     * @param {*} payload
     */
    AT_BUY_REQ_SINGLE: async ({ commit }, payload) => {
      const response = await authFetch.post(`/api/order/buy/step`, payload);
      const { flag, msg, data } = response.data;
      if (flag) {
        alert("성공적으로 처리되었습니다.");
      } else {
        switch (msg) {
          case "-4164":
            alert(`거래가능 최소 금액은 ${data} USDT 입니다`);
            break;
          case "-2019":
            alert(
              "자산이 부족합니다. 바이낸스 홈페이지에서 선물 계좌를 확인해주시기 바랍니다."
            );
            break;
          default:
            alert(
              "처리중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다."
            );
            break;
        }
      }
      commit("MU_TEST");
    },
    AT_BUY_REQ_STEPS: async ({ commit }, payload) => {
      const response = await authFetch.post(`/api/order/buy/steps`, payload);
      console.log(response);
      commit("MU_TEST");
    },
    AT_BUY_REQ_INIT: async ({ commit }, payload) => {
      const response = await authFetch.post(
        `/api/order/buy/init/${payload.stepPosition}/${payload.symbol}`,
        payload
      );

      if (response.status === 200 || response.status === 201) {
        const result = response.data;
        if (result === "FAIL") {
          alert(
            "바이낸스 거래에 실패했습니다. 잠시 후 다시 시도해주시기 바랍니다."
          );
        } else {
          alert("성공적으로 저장되었습니다.");
        }

        commit("MU_TEST");
      } else {
        alert("요청중 오류가 발생했습니다.");
      }
    },
    AT_BUY_REQ_STEPS_V2: async ({ commit }, payload) => {
      const response = await authFetch.post(
        `/api/order/buy/orderSteps`,
        payload
      );

      if (response.status == 200 || response.status == 201) {
        alert("성공적으로 저장되었습니다.");
      } else {
        alert("요청중 오류가 발생했습니다.");
      }
      commit("MU_TEST");
    },

    AT_SELL_REQ_STEPS_V2: async ({ commit }, payload) => {
      const response = await authFetch.post(
        `/api/order/sell/orderSteps`,
        payload
      );
      if (response.status == 200 || response.status == 201) {
        alert("성공적으로 저장되었습니다.");
      } else {
        alert("요청중 오류가 발생했습니다.");
      }
      commit("MU_TEST");
    },

    /**
     * 매도 설정 api 요청
     * @param {*} param0
     */
    AT_SELL_REQ: async ({ commit }, payload) => {
      try {
        const response = await authFetch.post(
          `/api/order/sell/${payload.position}/${payload.symbol}`,
          payload
        );
        const { flag, msg } = response.data;
        if (flag) {
          alert("성공적으로 요청되었습니다.");
          commit("MU_SELL_UPDATE", payload);
        } else {
          switch (msg) {
            case "NO_KEY":
              alert("api 키 및 secret key 를 설정해주시기 바랍니다");
              break;
            case "BAD_REQ":
              alert(
                "요청 값이 잘못되었습니다. 값을 확인 후 다시 시도해주시기 바랍니다"
              );
              break;
            case "BUY_REQUIRED":
              alert("매수 주문을 먼저 진행해주시기 바랍니다.");
              break;
            default:
              alert(
                "요청을 처리하는 도중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다"
              );
              break;
          }
        }
      } catch (e) {
        if (e.status === 400) {
          alert("입력 값을 확인해주시기 바랍니다");
          return false;
        } else {
          alert(
            "요청을 처리하는 도중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다"
          );
          return false;
        }
      }
    },

    AT_UPDATE_ORDER: async ({ commit }) => {
      try {
        const response = await authFetch("/api/order/buy/steps");
        const { buyType, sellType } = response.data;
        commit("MU_API_UPDATE", { buyType, sellType });
      } catch (e) {
        console.log(e);
      }
    },

    /* 특정 포지션 청산 로직 */
    AT_CLOSE_POSITION: async ({ commit }, { symbol, position, coinId }) => {
      // 1. close position api
      const serverResult = await authFetch.post(
        `/api/order/close/${symbol}/${position}/${coinId}`
      );
      // 2. parse result (response <Long>)
      const { closeResult, buyStop } = serverResult.data;
      // 3. result 0 : sucess , - 205 : no position, - 500 : server error
      const _closeResult = Number(closeResult);
      if (_closeResult === 0) {
        alert("성공적으로 요청되었습니다.");
      } else if (_closeResult === -205) {
        alert(
          "청산 가능한 포지션이 없습니다. 새로고침 후 다시 시도해주시기 바랍니다."
        );
      } else if (_closeResult === -500) {
        alert(
          "해당 포지션 청산 중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다."
        );
      }
      commit("MU_TEMP");
      return buyStop;
    },

    AT_CANCEL_POSITION: async ({ commit }, { symbol, position }) => {
      const response = await authFetch.post(
        `/api/order/stoporpulse/${position}/${symbol}`
      );
      if (response.status === 200 || response.status === 201) {
        alert("성공적으로 정지 되었습니다.");
      } else {
        alert("중지 도중 오류가 발생했습니다.");
      }

      // const response = await authFetch.post(
      //   `/api/order/cancel/order/all/${position}/${symbol}`
      // );
      // if (response.status === 200 || response.status === 201) {
      //   alert("성공적으로 중지 되었습니다.");
      // } else {
      //   alert("중지 중 오류가 발생했습니다.");
      // }
      commit("MU_TEMP");
    },
  },
};

export default buyStepStore;
